import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { FormSection } from '../../components/forms/FormSection';
import { FormStack } from '../../components/forms/FormStack';
import { NotificationPreferencesForm } from './notifications/NotificationPreferencesForm';

export const NotificationsSettings = () => {
  return (
    <FormStack maxW='xl'>
      <FormSection heading='Notifications' description='Manage your notification preferences here'>
        <ChakraV3.Separator />
        <NotificationPreferencesForm />
      </FormSection>
    </FormStack>
  );
};
